import { useRouter } from '../context/RouterContext';

/**
 * A normal <a href> that search engines can follow, but switches pages without reloading
 * when clicked (unless the visitor opens it in a new tab).
 */
export default function Link({ to, onClick, children, ...linkProps }) {
  const { navigate } = useRouter();

  const handleClick = (event) => {
    onClick?.(event);
    const opensElsewhere = event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0;
    if (event.defaultPrevented || opensElsewhere) return;
    event.preventDefault();
    navigate(to);
  };

  return (
    <a href={to} onClick={handleClick} {...linkProps}>
      {children}
    </a>
  );
}
